import { Button } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

export default function HeaderActionButton({ children, icon, onClick, disabled = false }) {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      endIcon={icon}
      className="normal-case"
      sx={{
        borderRadius: "999px",
        px: 2.5,
        py: 1,
        color: HNSColors.neutrals[900],
        backgroundColor: HNSColors.primary[400],
        "&:hover": {
          backgroundColor: HNSColors.primary[600],
          color: HNSColors.neutrals[900],
        },
      }}
    >
      {children}
    </Button>
  );
}